import React from "react";

const Logo = ({ inverted = false, compact = false }) => {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src="/brand/logo.png"
        alt="Sanatan Dharma — Har Ghar Ka Vishwas"
        className={`${compact ? "h-16" : "h-20 sm:h-24"} w-auto object-contain`}
        style={{ mixBlendMode: inverted ? "screen" : "multiply" }}
      />
    </div>
  );
};

export default Logo;
